import React from 'react'

function Button({title,value,setValue, ...props}) {
  return (
    <div {...props} className={`button`} >
        {title}
    </div>
  )
}

export default Button